import TableLayout from "../../../../layout/main/TableLayout";
import { formatNumber } from "../../../../../core/utils/common";
import { Column, Row } from "../../../../../styles/CommonStyles";
import DateTime from "../../../../common/utils/DateTime";
import Operation from "../../../../common/utils/Operation";
import UserLink from "../../../../common/utils/UserLink";
import useGetTableIndex from "../../../../../core/hooks/layout/useGetTableIndex";
import {
    TradeAmount,
    TradeTypeBadge
} from "../../../../../styles/main/orders";
import CoinMarket from "../../../../common/common/CoinMarket";
import { cardsTransferAttributes } from "../../../../../core/constants/headers";
import { useNavigate } from "react-router-dom";
import CoinRow from "../../../../common/common/CoinRow";


const CardsTransferTable = ({ data }) => {

    const { data: transfers } = data;
    const { cs, headers } = cardsTransferAttributes;
    const { getTableIndex } = useGetTableIndex();
    const navigate = useNavigate()



    return (
        <TableLayout
            headers={headers}
            cs={cs}
            data={data}
        >

            {transfers?.data?.map((transfer, idx) => {

                const isIn = transfer.type === "in";

                return (
                    <Row
                        key={transfer._id}
                        cs={cs}
                        index={idx}
                    >

                        <Column>
                            {getTableIndex(idx)}
                        </Column>

                        <Column avatar>
                            <UserLink
                                _id={transfer.userId}
                                name={transfer.user?.email}
                            />
                        </Column>

                        <Column>
                            <CoinRow
                                coin={{ id: transfer?.currency?.toLowerCase() }}
                            />
                        </Column>

                        <Column>
                            <TradeTypeBadge
                                color={isIn ? "#10b981" : "#ef4444"}
                            >
                                {transfer.type}
                            </TradeTypeBadge>
                        </Column>

                        <Column>
                            <TradeAmount
                                type={isIn ? "buy" : "sell"}
                            >
                                {formatNumber(transfer.amount)}
                            </TradeAmount>
                        </Column>

                        <Column>
                            <TradeTypeBadge
                                color={
                                    transfer.status === "success"
                                        ? "success"
                                        : transfer.status === "pending"
                                            ? "warning"
                                            : "danger"
                                }
                            >
                                {transfer.status}
                            </TradeTypeBadge>
                        </Column>

                        <Column>
                            {transfer.refCardId}
                        </Column>

                        <Column center>
                            <DateTime dt={transfer.createdAt} />
                        </Column>

                        <Column>
                            <Operation
                                hasDetails
                                onDetailsClicked={() => navigate(`/reports/cards/transfer/${transfer._id}`)}
                            />
                        </Column>

                    </Row>
                );
            })}

        </TableLayout>
    );
};

export default CardsTransferTable;